import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ClassThemeProvider } from '@class-ui/theme';
import { LegacyRecordingsProvider } from '../context/LegacyRecordingsContext';
import Recordings from '../components/legacyRecordings/Recordings';

const LegacyRecordingsPage = () => {
    const { ready } = useTranslation('lti');

    const renderPage = () => (
        <ClassThemeProvider>
            <LegacyRecordingsProvider>
                <Recordings />
            </LegacyRecordingsProvider>
        </ClassThemeProvider>
    );
    return ready ? renderPage() : <CircularProgress />;
};

export default LegacyRecordingsPage;
